import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function UserMenu() {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const navigate = useNavigate();

  // 💡 Obtener el perfil activo desde localStorage
  const perfilActivoId = localStorage.getItem('perfilActivoId');

  return (
    <>
      {/* Cabecera fija con botón y título */}
      <div style={styles.cabecera}>
        <button 
          style={styles.botonMenu}
          onClick={() => setMenuAbierto(!menuAbierto)}
        >
          ☰
        </button>
        <h1 style={styles.titulo}>MundiEmby</h1>
      </div>

      {/* Menú lateral desplegable */}
      {menuAbierto && (
        <div style={styles.menu}>
          <button style={styles.opcion} onClick={() => navigate('/dashboard')}>
            🏠 Inicio
          </button>
          <button
            style={styles.opcion}
            onClick={() => {
              if (perfilActivoId) {
                navigate(`/perfil/${perfilActivoId}`);
              } else {
                alert('No hay perfil activo seleccionado.');
              }
            }}
          >
            👤 Perfil
          </button>
          <button
            style={styles.opcion}
            onClick={() => {
              if (perfilActivoId) {
                navigate(`/perfil/${perfilActivoId}/ampliaciones`);
              } else {
                alert('No hay perfil activo seleccionado.');
              }
            }}
          >
            ⏱️ Ampliaciones
          </button>
          <button
  style={styles.opcion}
  onClick={() => {
    if (perfilActivoId) {
      navigate(`/perfil/${perfilActivoId}/peticiones`);
    } else {
      alert('No hay perfil activo seleccionado.');
    }
  }}
>
  📥 Peticiones
</button>

          <button style={styles.opcion} onClick={() => navigate('/noticias')}>
            📰 Noticias
          </button>
          <button style={styles.opcion} onClick={() => go('/descargas')}>
            ⬇️ Descargas
          </button>
          <button style={styles.cerrar} onClick={() => navigate('/')}>
            ⛔ Cerrar Sesión
          </button>
        </div>
      )}
    </>
  );
}

const styles = {
  cabecera: {
    position: 'fixed',
    top: '0',
    left: '0',
    zIndex: 1001,
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    backgroundColor: '#1e1e1e',
    padding: '10px 20px',
    height: '60px',
    width: '100%'
  },
  botonMenu: {
    backgroundColor: '#2b2b2b',
    border: 'none',
    color: 'white',
    fontSize: '20px',
    cursor: 'pointer',
    padding: '6px 12px',
    borderRadius: '4px',
    width: '40px',
    height: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  titulo: {
    fontSize: '24px',
    color: 'limegreen',
    margin: 0
  },
  menu: {
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1000,
    backgroundColor: '#2b2b2b',
    padding: '90px 20px 20px 20px',
    height: '100vh',
    width: '250px',
    boxShadow: '2px 0 10px rgba(0,0,0,0.5)',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  },
  opcion: {
    padding: '10px',
    backgroundColor: '#0078D7',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  cerrar: {
    padding: '10px',
    backgroundColor: 'crimson',
    color: 'white',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginTop: 'auto',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }
};

export default UserMenu;
